t = require('app/scripts/views/internal/teacup-with-helpers')('attachment_thumb_processing')

module.exports = t.renderable ->
  t.div '.attachment-thumbnail.attachment-thumbnail-processing.js-attachment-thumb-processing', ->
    t.format 'processing-ellipsis'
